import { render } from "solid-js/web";
import { App } from "./ui/app";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Portal root element was not found");
}

render(() => <App />, root);
